import { nextTick } from "vue";

export const formatTime = (timestamp: Date): string => {
  return timestamp.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const scrollToBottom = (messagesContainer: HTMLElement | undefined) => {
  nextTick(() => {
    if (messagesContainer) {
      messagesContainer.scrollTop = messagesContainer.scrollHeight;
    }
  });
};
